module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-790-min.ae662553.jpg";